export const GET_IVRS = "GET_IVRS";
export const LOADING_IVRS = 'LOADING_IVRS'